var InoCore;
(function (InoCore) {
    var Types;
    (function (Types) {
        var Event;
        (function (Event) {
            Event[Event["SelectedLanguageChange"] = 50] = "SelectedLanguageChange";
            Event[Event["Busy"] = 500] = "Busy";
            Event[Event["NotBusy"] = 501] = "NotBusy";
            Event[Event["UnhandledError"] = 600] = "UnhandledError";
        })(Event = Types.Event || (Types.Event = {}));
    })(Types = InoCore.Types || (InoCore.Types = {}));
})(InoCore || (InoCore = {}));
var InoCore;
(function (InoCore) {
    var Models;
    (function (Models) {
        var EventListenersContainer = (function () {
            function EventListenersContainer(eventId, eventState) {
                this.eventId = eventId;
                this.eventState = eventState;
                this.callbacks = new Array();
            }
            return EventListenersContainer;
        }());
        Models.EventListenersContainer = EventListenersContainer;
    })(Models = InoCore.Models || (InoCore.Models = {}));
})(InoCore || (InoCore = {}));
var InoCore;
(function (InoCore) {
    var Services;
    (function (Services) {
        var EventsHandlerService = (function () {
            function EventsHandlerService() {
                this.EventListenersContainers = new Array();
            }
            EventsHandlerService.Instance = function () {
                if (EventsHandlerService.instance == null)
                    EventsHandlerService.instance = new EventsHandlerService();
                return EventsHandlerService.instance;
            };
            EventsHandlerService.prototype.getEventListenersForEventId = function (eventId, eventState) {
                if (eventState === void 0) { eventState = InoCore.Types.EventState.On; }
                var eventListenersContainer = InoCore.Services.EventsHandlerService.Instance().EventListenersContainers.find(function (item) {
                    return item.eventId === eventId && item.eventState == eventState;
                });
                if (eventListenersContainer == null) {
                    eventListenersContainer = new InoCore.Models.EventListenersContainer(eventId, eventState);
                    InoCore.Services.EventsHandlerService.Instance().EventListenersContainers.push(eventListenersContainer);
                }
                return eventListenersContainer;
            };
            EventsHandlerService.subscribe = function (eventIds, callback, eventState) {
                if (eventState === void 0) { eventState = InoCore.Types.EventState.On; }
                if (typeof eventIds === "number")
                    EventsHandlerService.Instance().getEventListenersForEventId(eventIds, eventState).callbacks.push(callback);
                else
                    eventIds.forEach(function (eventId) {
                        EventsHandlerService.Instance().getEventListenersForEventId(eventId, eventState).callbacks.push(callback);
                    });
            };
            EventsHandlerService.trigger = function (eventId, payload) {
                var eventListeners_BEFORE = InoCore.Services.EventsHandlerService.Instance().getEventListenersForEventId(eventId, InoCore.Types.EventState.Before);
                var eventListeners_ON = InoCore.Services.EventsHandlerService.Instance().getEventListenersForEventId(eventId, InoCore.Types.EventState.On);
                var eventListeners_AFTER = InoCore.Services.EventsHandlerService.Instance().getEventListenersForEventId(eventId, InoCore.Types.EventState.After);
                var beforePromises = new Array();
                eventListeners_BEFORE.callbacks.forEach(function (callback) {
                    var result = callback(payload);
                    if (result instanceof Promise)
                        beforePromises.push(result);
                });
                Promise.all(beforePromises).then(function () {
                    var onPromises = new Array();
                    eventListeners_ON.callbacks.forEach(function (callback) {
                        var result = callback(payload);
                        if (result instanceof Promise)
                            onPromises.push(result);
                    });
                    Promise.all(onPromises).then(function () {
                        eventListeners_AFTER.callbacks.forEach(function (callback) {
                            callback(payload);
                        });
                    });
                });
            };
            return EventsHandlerService;
        }());
        Services.EventsHandlerService = EventsHandlerService;
    })(Services = InoCore.Services || (InoCore.Services = {}));
})(InoCore || (InoCore = {}));
var InoCore;
(function (InoCore) {
    function broadcastOnChange(eventIds) {
        return function (target, key) {
            var _val = this[key];
            var getter = function () {
                return _val;
            };
            var setter = function (newVal) {
                var triggerOnChange = _val !== newVal;
                _val = newVal;
                if (triggerOnChange) {
                    if (typeof eventIds === "number")
                        InoCore.Services.EventsHandlerService.trigger(eventIds);
                    else
                        eventIds.forEach(function (eventId) {
                            InoCore.Services.EventsHandlerService.trigger(eventId);
                        });
                }
            };
            if (delete this[key]) {
                Object.defineProperty(target, key, {
                    get: getter,
                    set: setter,
                    enumerable: true,
                    configurable: true
                });
            }
        };
    }
    InoCore.broadcastOnChange = broadcastOnChange;
})(InoCore || (InoCore = {}));
var InoCore;
(function (InoCore) {
    var Services;
    (function (Services) {
        var ConfigurationManager = (function () {
            function ConfigurationManager() {
                this.configs = {};
            }
            ConfigurationManager.Instance = function () {
                if (ConfigurationManager.instance == null)
                    ConfigurationManager.instance = new ConfigurationManager();
                return ConfigurationManager.instance;
            };
            ConfigurationManager.addConfigs = function (configs) {
                if (configs) {
                    for (var key in configs) {
                        if (key && configs[key]) {
                            if (ConfigurationManager.Instance().configs[key])
                                throw Error("The key variable \"" + key + "\" is already used in the ConfigurationManager.");
                            ConfigurationManager.Instance().configs[key] = configs[key];
                        }
                    }
                }
            };
            ConfigurationManager.addConfig = function (key, value) {
                if (key) {
                    if (ConfigurationManager.Instance().configs[key])
                        throw Error("The key variable \"" + key + "\" is already used in the ConfigurationManager.");
                    ConfigurationManager.Instance().configs[key] = value;
                }
            };
            ConfigurationManager.AppSettings = function (key) {
                return ConfigurationManager.Instance().configs[key];
            };
            Object.defineProperty(ConfigurationManager, "templateUrlOverrides", {
                get: function () {
                    return ConfigurationManager.AppSettings(ConfigurationManager.templateUrlOverridesKey);
                },
                enumerable: true,
                configurable: true
            });
            ConfigurationManager.addTemplateUrlOverrides = function (value) {
                var currentValue = ConfigurationManager.templateUrlOverrides;
                if (!currentValue)
                    ConfigurationManager.addConfig(ConfigurationManager.templateUrlOverridesKey, value);
                else {
                    for (var prop in value) {
                        currentValue[prop] = value[prop];
                    }
                }
            };
            ConfigurationManager.templateUrlOverridesKey = "templateUrlOverrides";
            return ConfigurationManager;
        }());
        Services.ConfigurationManager = ConfigurationManager;
    })(Services = InoCore.Services || (InoCore.Services = {}));
})(InoCore || (InoCore = {}));
var InoCore;
(function (InoCore) {
    var Types;
    (function (Types) {
        var Language;
        (function (Language) {
            Language[Language["English"] = 0] = "English";
            Language[Language["French"] = 1] = "French";
        })(Language = Types.Language || (Types.Language = {}));
    })(Types = InoCore.Types || (InoCore.Types = {}));
})(InoCore || (InoCore = {}));
var InoCore;
(function (InoCore) {
    function config() {
        return function (contructor) {
            var configs = {};
            contructor.call(configs);
            InoCore.Services.ConfigurationManager.addConfigs(configs);
        };
    }
    InoCore.config = config;
})(InoCore || (InoCore = {}));
var InoCore;
(function (InoCore) {
    var Services;
    (function (Services) {
        var ResourceManagerService = (function () {
            function ResourceManagerService() {
                this.enResources = {};
                this.frResources = {};
                inovestor.ms.ko.currentLanguage.subscribe(function (language) {
                    InoCore.Services.EventsHandlerService.trigger(InoCore.Types.Event.SelectedLanguageChange);
                });
            }
            ResourceManagerService.Instance = function () {
                if (ResourceManagerService.instance == null)
                    ResourceManagerService.instance = new ResourceManagerService();
                return ResourceManagerService.instance;
            };
            ResourceManagerService.currentResource = function () {
                var currentLanguage = inovestor.ms.ko.currentLanguage();
                if (currentLanguage == 'fr')
                    return InoCore.Services.ResourceManagerService.Instance().frResources;
                else
                    return InoCore.Services.ResourceManagerService.Instance().enResources;
            };
            ResourceManagerService.addResources = function (cultureCode, resources, namespace) {
                switch (cultureCode) {
                    case InoCore.Types.Language.French:
                        InoCore.Services.ResourceManagerService.Instance().frResources[namespace] = resources;
                        break;
                    case InoCore.Types.Language.English:
                    default:
                        InoCore.Services.ResourceManagerService.Instance().enResources[namespace] = resources;
                        break;
                }
            };
            return ResourceManagerService;
        }());
        Services.ResourceManagerService = ResourceManagerService;
    })(Services = InoCore.Services || (InoCore.Services = {}));
})(InoCore || (InoCore = {}));
var InoCore;
(function (InoCore) {
    function resourceKey(cultureCode, namespace) {
        if (namespace === void 0) { namespace = "General"; }
        return function (contructor) {
            var resources = {};
            contructor.call(resources);
            InoCore.Services.ResourceManagerService.addResources(cultureCode, resources, namespace);
        };
    }
    InoCore.resourceKey = resourceKey;
})(InoCore || (InoCore = {}));
var InoCore;
(function (InoCore) {
    var Models;
    (function (Models) {
        var MsCoreXHR = (function () {
            function MsCoreXHR(data, textStatus, url, response) {
                this.data = data;
                this.url = url;
                this.response = response;
                this.textStatus = textStatus;
            }
            return MsCoreXHR;
        }());
        Models.MsCoreXHR = MsCoreXHR;
    })(Models = InoCore.Models || (InoCore.Models = {}));
})(InoCore || (InoCore = {}));
var InoCore;
(function (InoCore) {
    var Components;
    (function (Components) {
        var Basic;
        (function (Basic) {
            var BaseComponent = (function () {
                function BaseComponent(htmlTagName, templateUrl, viewModel) {
                    this.htmlTagName = htmlTagName;
                    this.templateUrl = templateUrl;
                    this.viewModel = viewModel;
                }
                BaseComponent.prototype.getHtmlTagName = function () {
                    return this.htmlTagName;
                };
                BaseComponent.prototype.init = function () {
                    var _this = this;
                    return new Promise(function (resolve, reject) {
                        _this.getTemplateAsync().then(function () {
                            resolve();
                        }).catch(function () {
                            reject();
                        });
                    });
                };
                BaseComponent.prototype.getTemplateAsync = function () {
                    var _this = this;
                    return new Promise(function (resolve, reject) {
                        var templateUrlOverrides = InoCore.Services.ConfigurationManager.templateUrlOverrides;
                        var templateUrl = _this.templateUrl;
                        if (templateUrlOverrides && templateUrlOverrides[templateUrl])
                            templateUrl = templateUrlOverrides[templateUrl];
                        inovestor.ms.core.getTemplate(templateUrl, templateUrl).then(function (template) {
                            resolve(template);
                        });
                    });
                };
                BaseComponent.prototype.registerView = function (template) {
                    if (ko.components.isRegistered(this.htmlTagName))
                        return;
                    var _that = this;
                    ko.components.register(this.htmlTagName, {
                        viewModel: function () { return _that.viewModel; },
                        template: template
                    });
                };
                return BaseComponent;
            }());
            Basic.BaseComponent = BaseComponent;
        })(Basic = Components.Basic || (Components.Basic = {}));
    })(Components = InoCore.Components || (InoCore.Components = {}));
})(InoCore || (InoCore = {}));
var InoCore;
(function (InoCore) {
    var Models;
    (function (Models) {
        var DataServiceAppData = (function () {
            function DataServiceAppData() {
                this.apiBaseUrl = null;
                this.onApiErrorHandler = null;
            }
            return DataServiceAppData;
        }());
        Models.DataServiceAppData = DataServiceAppData;
    })(Models = InoCore.Models || (InoCore.Models = {}));
})(InoCore || (InoCore = {}));
var InoCore;
(function (InoCore) {
    var Services;
    (function (Services) {
        var DataService = (function () {
            function DataService(dataServiceAppData) {
                this.dataServiceAppData = dataServiceAppData;
            }
            DataService.requestStarted = function () {
                if (DataService.pendingRequestCounter == 0)
                    InoCore.Services.EventsHandlerService.trigger(InoCore.Types.Event.Busy);
                DataService.pendingRequestCounter++;
            };
            DataService.requestCompleted = function () {
                DataService.pendingRequestCounter--;
                if (DataService.pendingRequestCounter == 0)
                    InoCore.Services.EventsHandlerService.trigger(InoCore.Types.Event.NotBusy);
            };
            DataService.prototype.sendRequestAsync = function (relativeUrl, options) {
                var _that = this;
                return new Promise(function (resolve, reject) {
                    DataService.requestStarted();
                    var url = inovestor.ms.core.concatUrl(_that.dataServiceAppData.apiBaseUrl, relativeUrl);
                    inovestor.ms.core.ajaxApi(relativeUrl, options, _that.dataServiceAppData.apiBaseUrl)
                        .then(function (data, textStatus, response) {
                        resolve(new InoCore.Models.MsCoreXHR(data, textStatus, url, response));
                    }).fail(function (response, textStatus, errorThrown) {
                        if (_that.dataServiceAppData.onApiErrorHandler)
                            _that.dataServiceAppData.onApiErrorHandler.call(errorThrown, response, this);
                        reject(new InoCore.Models.MsCoreXHR(errorThrown, textStatus, url, response));
                    }).always(function () {
                        DataService.requestCompleted();
                    });
                });
            };
            DataService.pendingRequestCounter = 0;
            return DataService;
        }());
        Services.DataService = DataService;
    })(Services = InoCore.Services || (InoCore.Services = {}));
})(InoCore || (InoCore = {}));
var InoCore;
(function (InoCore) {
    var Services;
    (function (Services) {
        var NavigationService = (function () {
            function NavigationService(viewService) {
                this.views = new Array();
                this.viewService = viewService;
            }
            NavigationService.prototype.addView = function (viewId) {
                var view = this.viewService.getView(viewId);
                if (!view)
                    throw Error("Cannot find view matching id: \"" + viewId + "\"");
                this.views.push(view);
            };
            NavigationService.prototype.removeView = function (viewId) {
                var view = this.views.find(function (p) { return p.id === viewId; });
                if (!view)
                    throw Error("Cannot find view matching id: \"" + viewId + "\"");
                var index = this.views.indexOf(view);
                if (index >= 0)
                    this.views.splice(index, 1);
            };
            NavigationService.prototype.Views = function () {
                return this.views;
            };
            return NavigationService;
        }());
        Services.NavigationService = NavigationService;
    })(Services = InoCore.Services || (InoCore.Services = {}));
})(InoCore || (InoCore = {}));
var InoCore;
(function (InoCore) {
    var Services;
    (function (Services) {
        var ViewService = (function () {
            function ViewService() {
                this.registeredViews = new Array();
            }
            ViewService.prototype.getView = function (viewId) {
                return this.registeredViews.find(function (p) { return p.id === viewId; });
            };
            ViewService.prototype.removeView = function (viewId) {
                var registeredView = this.getView(viewId);
                if (registeredView) {
                    var index = this.registeredViews.indexOf(registeredView);
                    if (index >= 0)
                        this.registeredViews.splice(index, 1);
                }
            };
            ViewService.prototype.registerView = function (view) {
                var registeredView = this.getView(view.id);
                if (registeredView)
                    throw Error("The view id \"" + registeredView.id + "\" is already used. Please remove the view before trying to replace it.");
                this.registeredViews.push(view);
            };
            ViewService.prototype.registerCustomView = function (options) {
                if (options.id == null)
                    throw Error("custom view id cannot be null");
                if (options.templateUrl == null)
                    throw Error("custom view templateUrl cannot be null");
                if (options.viewModel == null)
                    throw Error("custom view viewModel cannot be null");
                if (options.navigationResourceKey == null)
                    throw Error("custom view navigationResourceKey cannot be null");
                var component = new InoCore.Components.Custom.CustomViewComponent(options.id, options.templateUrl, options.viewModel);
                this.registerView({ id: options.id, resourceKey: options.navigationResourceKey, component: component });
            };
            return ViewService;
        }());
        Services.ViewService = ViewService;
    })(Services = InoCore.Services || (InoCore.Services = {}));
})(InoCore || (InoCore = {}));
var InoCore;
(function (InoCore) {
    var Types;
    (function (Types) {
        var EventState;
        (function (EventState) {
            EventState[EventState["Before"] = 0] = "Before";
            EventState[EventState["On"] = 1] = "On";
            EventState[EventState["After"] = 2] = "After";
        })(EventState = Types.EventState || (Types.EventState = {}));
    })(Types = InoCore.Types || (InoCore.Types = {}));
})(InoCore || (InoCore = {}));
var InoCore;
(function (InoCore) {
    var Types;
    (function (Types) {
        var ModalEvent;
        (function (ModalEvent) {
            ModalEvent[ModalEvent["onOpen"] = 0] = "onOpen";
            ModalEvent[ModalEvent["onOpened"] = 1] = "onOpened";
            ModalEvent[ModalEvent["onClose"] = 2] = "onClose";
            ModalEvent[ModalEvent["onClosed"] = 3] = "onClosed";
        })(ModalEvent = Types.ModalEvent || (Types.ModalEvent = {}));
    })(Types = InoCore.Types || (InoCore.Types = {}));
})(InoCore || (InoCore = {}));
var InoCore;
(function (InoCore) {
    var Components;
    (function (Components) {
        var Basic;
        (function (Basic) {
            var BaseViewModel = (function () {
                function BaseViewModel() {
                    var _this = this;
                    this.init = function () { };
                    this.resources = ko.observable(null);
                    this.resources(InoCore.Services.ResourceManagerService.currentResource());
                    InoCore.Services.EventsHandlerService.subscribe(InoCore.Types.Event.SelectedLanguageChange, function () {
                        _this.resources(InoCore.Services.ResourceManagerService.currentResource());
                    });
                }
                return BaseViewModel;
            }());
            Basic.BaseViewModel = BaseViewModel;
        })(Basic = Components.Basic || (Components.Basic = {}));
    })(Components = InoCore.Components || (InoCore.Components = {}));
})(InoCore || (InoCore = {}));
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var InoCore;
(function (InoCore) {
    var Components;
    (function (Components) {
        var Custom;
        (function (Custom) {
            var CustomViewComponent = (function (_super) {
                __extends(CustomViewComponent, _super);
                function CustomViewComponent(id, templateUrl, viewModel) {
                    return _super.call(this, id, templateUrl, viewModel) || this;
                }
                CustomViewComponent.prototype.render = function () {
                    var _this = this;
                    return new Promise(function (resolve, reject) {
                        _this.viewModel.init();
                        resolve();
                    });
                };
                return CustomViewComponent;
            }(InoCore.Components.Basic.BaseComponent));
            Custom.CustomViewComponent = CustomViewComponent;
        })(Custom = Components.Custom || (Components.Custom = {}));
    })(Components = InoCore.Components || (InoCore.Components = {}));
})(InoCore || (InoCore = {}));
var InoCore;
(function (InoCore) {
    var Components;
    (function (Components) {
        var Modal;
        (function (Modal) {
            var ModalBaseViewModel = (function (_super) {
                __extends(ModalBaseViewModel, _super);
                function ModalBaseViewModel() {
                    var _this = _super.call(this) || this;
                    _this.closeModal = function () { return null; };
                    _this.openModal = function () { return null; };
                    return _this;
                }
                return ModalBaseViewModel;
            }(InoCore.Components.Basic.BaseViewModel));
            Modal.ModalBaseViewModel = ModalBaseViewModel;
        })(Modal = Components.Modal || (Components.Modal = {}));
    })(Components = InoCore.Components || (InoCore.Components = {}));
})(InoCore || (InoCore = {}));
var InoCore;
(function (InoCore) {
    var Components;
    (function (Components) {
        var Modal;
        (function (Modal) {
            var ModalBaseComponent = (function (_super) {
                __extends(ModalBaseComponent, _super);
                function ModalBaseComponent(htmlTagName, templateUrl, viewModel) {
                    var _this = _super.call(this, htmlTagName, templateUrl, viewModel) || this;
                    _this.openModal = function () {
                        $(_this.htmlTagName).find('.modal').modal('show');
                    };
                    _this.closeModal = function () {
                        $(_this.htmlTagName).find('.modal').modal('hide');
                    };
                    viewModel.openModal = _this.openModal;
                    viewModel.closeModal = _this.closeModal;
                    return _this;
                }
                ModalBaseComponent.prototype.render = function () {
                    var _this = this;
                    return new Promise(function (resolve, reject) {
                        _this.getTemplateAsync().then(function (template) {
                            var newTemplate = '<div class="modal fade" tabindex="-1" role="dialog" data-backdrop="static"><div class="modal-dialog" role="document"><div class="modal-content">' +
                                template +
                                '</div><!-- /.modal-content --></div><!-- /.modal-dialog --></div><!-- /.modal -->';
                            _this.registerView(newTemplate);
                            resolve();
                        });
                    });
                };
                ModalBaseComponent.prototype.enableModalKeyboard = function (value) {
                    var modal = $(this.htmlTagName).find('.modal').data('bs.modal');
                    if (modal)
                        modal.options.keyboard = value;
                    else
                        $(this.htmlTagName).find('.modal').modal({
                            show: false,
                            keyboard: value
                        });
                };
                ModalBaseComponent.prototype.addEventHandler = function (event, callback) {
                    var eventName = null;
                    switch (event) {
                        case InoCore.Types.ModalEvent.onOpen:
                            eventName = 'show.bs.modal';
                            break;
                        case InoCore.Types.ModalEvent.onOpened:
                            eventName = 'shown.bs.modal';
                            break;
                        case InoCore.Types.ModalEvent.onClose:
                            eventName = 'hide.bs.modal';
                            break;
                        case InoCore.Types.ModalEvent.onClosed:
                            eventName = 'hidden.bs.modal';
                            break;
                        default:
                            break;
                    }
                    if (eventName != null) {
                        $(this.htmlTagName).find('.modal').on(eventName, function () {
                            callback();
                        });
                    }
                };
                return ModalBaseComponent;
            }(InoCore.Components.Basic.BaseComponent));
            Modal.ModalBaseComponent = ModalBaseComponent;
        })(Modal = Components.Modal || (Components.Modal = {}));
    })(Components = InoCore.Components || (InoCore.Components = {}));
})(InoCore || (InoCore = {}));
